import { onFontsReady } from "../utils/onFontsReady";
import { initFontsGate } from "../utils/initFontsGate";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

initFontsGate("Manrope", [400, 700]);
gsap.registerPlugin(ScrollTrigger);

function initWhyUs(wrapper) {
	if (!wrapper || wrapper.dataset.gsapWhyUsInited) return;
	wrapper.dataset.gsapWhyUsInited = "1";

	if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

	const content = wrapper.querySelector(".wv-dynamic-content-wrapper");
	const titleBits = content ? Array.from(content.children) : [];
	const items = Array.from(wrapper.querySelectorAll(".webvibe-contact-item"));

	if (titleBits.length) {
		gsap.set(titleBits, { opacity: 0, y: 14 });

		gsap.to(titleBits, {
			opacity: 1,
			y: 0,
			duration: 0.6,
			stagger: 0.08,
			ease: "power2.out",
			clearProps: "transform,opacity",
			scrollTrigger: {
				trigger: wrapper,
				start: "top 75%",
				once: true,
			},
		});
	}

	items.forEach((item) => {
		const icon = item.querySelector(".webvibe-contact-item__image img");
		const label = item.querySelector("p");

		gsap.set(item, { opacity: 0, y: 16 });
		if (icon) gsap.set(icon, { opacity: 0, scale: 0.96 });
		if (label) gsap.set(label, { opacity: 0, y: 5 });

		const tl = gsap.timeline({ paused: true, defaults: { ease: "power2.out" } });

		tl.to(item, {
			opacity: 1,
			y: 0,
			duration: 0.55,
			clearProps: "transform,opacity",
		});

		if (icon) {
			tl.to(
				icon,
				{ opacity: 1, scale: 1, duration: 0.35, clearProps: "transform,opacity" },
				"-=0.35"
			);
		}

		if (label) {
			tl.to(
				label,
				{ opacity: 1, y: 0, duration: 0.28, clearProps: "transform,opacity" },
				"-=0.28"
			);
		}

		ScrollTrigger.create({
			trigger: item,
			start: "top 80%",
			once: true,
			onEnter: () => tl.play(),
		});
	});

	const imgs = wrapper.querySelectorAll("img");
	imgs.forEach((im) => {
		if (im.complete) return;
		im.addEventListener("load", () => ScrollTrigger.refresh(), { once: true });
		im.addEventListener("error", () => ScrollTrigger.refresh(), { once: true });
	});
}

onFontsReady(() => {
	document.querySelectorAll(".wv-gsap-why-we").forEach(initWhyUs);
	ScrollTrigger.refresh();
});
